// extracted by mini-css-extract-plugin
export default {"badge":"components-general-smart-insights-upsell-badge-year-view-module__badge"};